module.exports = __webpack_public_path__ + "staticcomp/img/content_1.e9ca579.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/5/content_1.jpg
// module id = hOh9
// module chunks = 39